module.exports = __webpack_public_path__ + "static/media/icon_analytics.b2b0689c.png";